module.exports = __webpack_public_path__ + "img/logo@2x.52399c7f.png";